import "./styles.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../../context/ConfigContext";
import { useTranslation } from "react-i18next";
import { generateUUID } from "../../services/uidService";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import Button from "../Button/Button";
import { LanguageSelector } from "../LanguageSelector/LanguageSelector";

export const MobilePage = ({ onFinish }) => {
  const { t, i18n } = useTranslation(["customHomeInfo", "homeModule"]);
  const { uid, updateUID } = useUID();
  const trackEvent = useAmplitude();
  const { logo, configData, updatePartnerName } = useConfig();
  const navigate = useNavigate();

  const onFinishWithPartnerName = (type) => {
    updatePartnerName(`glueckauf-${type}`);
    trackEvent(
      "webapp_user_press_continue_home",
      uid,
      "",
      "",
      "",
      "",
      `glueckauf-${type}`,
    );

    onFinish();
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isScanned = params.get("scanned");
    const newUid = generateUUID();

    updateUID(newUid);

    // Log events if user scanned QR and visited on mobile
    // If user visited first time from QR-scan
    if (isScanned) {
      trackEvent("webapp_user_scanned_qr", newUid);
      params.delete("scanned");
      // Update the URL without reloading the page
      navigate(
        {
          pathname: window.location.pathname,
          search: params.toString(),
        },
        { replace: true },
      );
    }

    trackEvent("webapp_user_visited_home", newUid, "", "", "", "", "general");
  }, [navigate, updateUID, trackEvent, i18n]);

  return (
    <div className="mobile-welcome-home">
      <div className="customer-logo-container">
        <img
          src={logo}
          alt="Logo"
          width="320"
          style={{
            width: "75vmin",
            maxWidth: "360px",
          }}
        />
      </div>
      {configData?.availableLanguages?.length > 1 && (
        <div className="language-selector">
          <LanguageSelector />
        </div>
      )}
      <div className="info-text">
        <h2 className="title-text">{t("custom-home-title")}</h2>
        <p className="home-sub-title">{t("custom-home-subtitle")}</p>
      </div>
      <div className="home-button-wrapper">
        {[
          {
            key: "homeModule:skinAnalysis-button",
            type: "skin",
          },
          {
            key: "homeModule:hairAnalysis-button",
            type: "hair",
          },
          {
            key: "homeModule:lipAnalysis-button",
            type: "lips",
          },
        ].map(({ key, icon, type }) => (
          <Button
            key={key}
            text={t(key)}
            icon={icon}
            onClick={() => onFinishWithPartnerName(type)}
          />
        ))}
      </div>
    </div>
  );
};
